<template>
<v-flex xs12 class="loading">
    <v-layout align-center>
        <img src="../assets/img/loading.svg" class="flex">
    </v-layout>
</v-flex>
</template>

<script>
export default {
	name: 'loading',
	data() {
		return {

		}
	},
	mounted() {},
	methods: {

	}
}
</script>

<style lang="scss" scoped>
.loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-100%);
    z-index: 1;
}
</style>
